export default function Section2() {
    const services = [
      "Logo",
      "Business Cards & Stationary",
      "Social Media Posts",
      "Website Banners and Sliders",
      "Packaging",
      "T-Shirt Designs",
      "Book Covers",
      "Company Profile",
    ];
  
    return (
      <div className="Section2 py-[35px] bg-[#F5F5F5]">
        <div className="container-1280 section2-container flex flex-col xl:flex-row w-full relative px-[15px] mx-auto md:w-[750px] lg:w-[970px] xl:w-[100%] group mb-[20px]">
          {/* Circle with Icon */}
          <div className="relative flex md:flex-col justify-center  xl:items-center">
            <div className="w-[75px] h-[80px] rounded-[50%] group-hover:shadow-[inset_0_0_0_44px_#cd2122] shadow-[inset_0_0_0_2px_#cd2122] relative transition-all ease-in-out duration-300">
              <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 font-kl text-[22px] text-[#cd2122] transition-all ease-in-out duration-300 group-hover:text-white">
                <span className="text-[#cd2122] group-hover:text-white"></span>
              </div>
            </div>
  
            {/* Vertical Line */}
            <div className="h-full hidden xl:block w-[1px] bg-[rgba(0,0,0,.07)]"></div>
          </div>
  
          {/* Text Content */}
          <div className="text-[#535353] text-center md:text-left xl:ml-5 font-open">
            <h2 className="text-[24px] leading-[32px] md:text-[34px] font-mont font-bold text-[#DA2128] md:leading-[40px] my-[0.67em]">
              Services We Provide
            </h2>
  
            <p className="text-[18px] mb-5">
              You can choose our Graphic Designing services from a wide range of
              areas, tailoring to your specific needs. We communicate
              professionally and creatively through high-resolution graphics. This
              team consists of designing:
            </p>
  
            <ul>
              {services.map((service, index) => (
                <li
                  key={index}
                  className="relative text-[18px] mb-5  before:absolute before:hidden xl:before:block before:rounded-[50%] before:-left-[63px] before:top-[8px] before:shadow-[0_0_0_2px_#cd2122] before:w-[6px] before:h-[6px] before:bg-[#fff] hover:before:shadow-[0_0_0_3px_#cd2122] before:transition-all before:ease-in-out before:duration-[.15s]"
                >
                  {service}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    );
  }
  